import router from '@/plugins/Router'
import LocalStorage from "@/plugins/LocalStorage";
import {setWithExpiry,getWithExpiry} from "@/libs/Helpers";

const module = {
    namespaced: true,
    state: () => ({
        sessionTime: 60 * 60 *1000, //1 saat,
        difference:0
    }),
    getters: {
        getExpiryIn(state){
            return state.sessionTime
        },
        checkIsLogin(){
           const studentForm =getWithExpiry('specialStudentData',true)
           const sessionDeadline =getWithExpiry('specialstudentSessionDeadline',true)
            if (!studentForm && !sessionDeadline && router.currentRoute.path!=='/special-student/application/login'){
                return router.push('/special-student/application/login')
            }
            if (studentForm && sessionDeadline && router.currentRoute.path!=='/special-student/application/form'){
                return router.push('/special-student/application/form')
            }
        },
    },
    mutations: {
        clearData(state){
            LocalStorage.remove('specialStudentData')
            LocalStorage.remove('specialstudentSessionDeadline')
            LocalStorage.remove('tabIndex')
            LocalStorage.remove('sepecialStudentWarningModal')
        },
        setLoginData(state,data){
            setWithExpiry('specialStudentData',data,state.sessionTime,true)
            setWithExpiry('specialstudentSessionDeadline',state.sessionTime,state.sessionTime,true)
            setWithExpiry('sepecialStudentWarningModal',false,state.sessionTime,true)
        },
        setDifference(state,data){
           state.difference=data
        },
    },
    actions: {
        logout({commit}) {
            commit("clearData")
            router.push('/special-student/application/login');
        },
        setLoginData({commit},data) {
            commit("setLoginData",data)
        },
        setDifference({commit},data){
           commit("setDifference",data)
        }

    }

}

export default module;
